module.exports = __webpack_public_path__ + "static/media/own-goal.dbda0b03.svg";